import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { ApiHandlerDiscreteParameter, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { GetWishListsApiParameter } from "@insite/client-framework/Services/WishListService";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import loadWishList from "@insite/client-framework/Store/Data/WishLists/Handlers/LoadWishList";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import {
    chain,
    DispatchLoadWishListIfNeeded,
} from "@insite/client-framework/Store/Pages/MyListDetails/Handlers/LoadWishListIfNeeded";
import { OrderModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = ApiHandlerDiscreteParameter<
    { wishListId: string; keepLinesParameter?: boolean },
    GetWishListsApiParameter,
    OrderModel
>;

export const DispatchLoadWishListIfNeededCustom: HandlerType = props => {
    const wishListState = getWishListState(props.getState(), props.parameter.wishListId);

    const location = getLocation(props.getState());
    const parsedQuery = parseQueryString<{ id?: string; customerId?: string }>(location.search);

    if (
        !wishListState.value ||
        wishListState.value.schedule === undefined ||
        !wishListState.value.sendDayOfMonthPossibleValues ||
        !wishListState.value.sendDayOfWeekPossibleValues ||
        wishListState.value.sendDayOfMonthPossibleValues.length < 1 ||
        wishListState.value.sendDayOfWeekPossibleValues.length < 1 ||
        wishListState.value.wishListTags === null
    ) {
        props.dispatch(
            loadWishList({
                wishListId: props.parameter.wishListId,
                exclude: ["listLines"],
                expand: ["schedule", "sharedUsers", "favorite", "hidden", "tags"],
                ...(parsedQuery.customerId && {
                    customerId: parsedQuery.customerId,
                }),
            }),
        );
    }
};

replaceInChain(chain, DispatchLoadWishListIfNeeded, DispatchLoadWishListIfNeededCustom);
